
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkit",
      function () {
        return require("private-next-pages/toolkit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkit"])
      });
    }
  